import * as THREE from 'three'
import { Component } from '@ecs/Component'
import { TransformData } from '@components/Transform'

export class Renderer extends Component {
  object3D!: THREE.Object3D
  renderTransform?: TransformData

  setup(data: any) {
    this.object3D = new THREE.Object3D()
    this.renderTransform = data.renderTransform
  }
  start() {
    this.scene.threeScene.add(this.object3D)
    this.object3D.name = this.gameObject.name
  }
  onMove(): void {
    this.syncronize()
  }
  syncronize() {
    let renderTransform = this.renderTransform || new TransformData()
    renderTransform = renderTransform.TransformLocalToWorld(this.gameObject.transform.transformData)
    this.object3D.position.copy(renderTransform.position)
    this.object3D.rotation.copy(renderTransform.rotation)
    this.object3D.scale.copy(renderTransform.scale)
  }
  render(_dt: number) {
  }
  onDestroy() {
    this.scene.threeScene.remove(this.object3D)
  }
}
